/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class HomeApplianceService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 가전 목록 조회 */
    getApplianceList = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/smart-things/${siteId}`));
        return data;
    };
    /** 가전 연결 상태 조회 */
    getApplianceStatus = async (deviceId) => {
        return await this.get(`/devices/${deviceId}/status`);
    };
    /** 가전 정보 조회 */
    getApplianceInfo = async (deviceId) => {
        return await this.get(`/devices/${deviceId}`);
    };
    /** 가전 상태 조회 */
    getApplianceHealth = async (deviceId) => {
        return await this.get(`/devices/${deviceId}/health`);
    };
    /** 가전 위치 목록 조회 */
    getApplianceLocations = async () => {
        const { items } = await this.get('/locations');
        return items;
    };
    /** 가전 방 목록 조회 */
    getApplianceRooms = async (locationId) => {
        const { items } = await this.get(`/locations/${locationId}/rooms`);
        return items;
    };
    /** 가전 제어 */
    controlAppliance = async (deviceId, params) => {
        return await this.post(`/devices/${deviceId}/commands`, params);
    };
    /** 가전 토큰 갱신 */
    refreshSmartThingsToken = async (token) => {
        const { data } = await this.post(apiWrapper.managerApi('/smart-things/tokens/refresh'), { token });
        return data;
    };
    /** 가전 차트 조회 */
    getApplianceChart = async (siteId, params) => {
        const { data } = await this.get(apiWrapper.managerApi(`/smart-things/charts/${siteId}`), params);
        return data;
    };
    /** 가전 별 차트 조회 */
    getChartByAppliance = async (applianceDeivceId, params) => {
        const { data } = await this.get(apiWrapper.managerApi(`/smart-things/charts/${applianceDeivceId}/powers`), params);
        return data;
    };
}
